const suppliersSeed = [
  {
    id: 'prov-1',
    razonSocial: 'Transporte Andino SRL',
    cuit: '30-71234567-9',
    condicionIva: 'Responsable Inscripto',
    email: 'facturacion@transporteandino.com',
    telefono: '+54 11 4567-1200',
    domicilio: {
      calle: 'Av. San Martín',
      numero: '2450',
      piso: '3',
      dpto: 'A',
      localidad: 'Ciudad de Buenos Aires',
      provincia: 'Buenos Aires',
      cp: '1414',
    },
    observaciones: 'Proveedor habitual de transporte refrigerado.',
    activo: true,
    createdAt: '2024-05-10T12:30:00.000Z',
    updatedAt: '2024-11-02T17:45:00.000Z',
  },
  {
    id: 'prov-2',
    razonSocial: 'Servicios La Plata SA',
    cuit: '30-69874521-7',
    condicionIva: 'Responsable Inscripto',
    email: 'administracion@slp.com.ar',
    telefono: '+54 221 523-9987',
    domicilio: {
      calle: 'Calle 13',
      numero: '1456',
      piso: '',
      dpto: '',
      localidad: 'La Plata',
      provincia: 'Buenos Aires',
      cp: '1900',
    },
    observaciones: 'Cuenta corriente a 30 días.',
    activo: true,
    createdAt: '2024-04-02T15:10:00.000Z',
    updatedAt: '2024-08-15T09:20:00.000Z',
  },
  {
    id: 'prov-3',
    razonSocial: 'Estudio Contable Norte',
    cuit: '20-23876543-2',
    condicionIva: 'Monotributo',
    email: 'info@ecnorte.com',
    telefono: '+54 381 410-2030',
    domicilio: {
      calle: 'Gral. Paz',
      numero: '189',
      piso: '1',
      dpto: 'B',
      localidad: 'San Miguel de Tucumán',
      provincia: 'Tucumán',
      cp: '4000',
    },
    observaciones: 'Servicios contables tercerizados.',
    activo: true,
    createdAt: '2023-12-12T11:00:00.000Z',
    updatedAt: '2024-09-30T10:35:00.000Z',
  },
  {
    id: 'prov-4',
    razonSocial: 'Insumos Patagónicos',
    cuit: '30-45321109-5',
    condicionIva: 'Exento',
    email: 'ventas@insumospatag.com',
    telefono: '+54 294 442-9981',
    domicilio: {
      calle: 'Mitre',
      numero: '120',
      piso: '',
      dpto: '',
      localidad: 'Bariloche',
      provincia: 'Río Negro',
      cp: '8400',
    },
    observaciones: 'Entrega en sucursal central semanal.',
    activo: false,
    createdAt: '2022-09-08T09:45:00.000Z',
    updatedAt: '2024-07-19T14:30:00.000Z',
  },
  {
    id: 'prov-5',
    razonSocial: 'Soluciones Digitales del Litoral',
    cuit: '27-30981234-4',
    condicionIva: 'Responsable Inscripto',
    email: 'soporte@sdlitoral.com',
    telefono: '+54 341 512-6630',
    domicilio: {
      calle: 'Bv. Oroño',
      numero: '3012',
      piso: '6',
      dpto: 'C',
      localidad: 'Rosario',
      provincia: 'Santa Fe',
      cp: '2000',
    },
    observaciones: 'Soporte técnico remoto 24/7.',
    activo: true,
    createdAt: '2023-02-21T13:20:00.000Z',
    updatedAt: '2024-10-11T08:55:00.000Z',
  },
];

export function createSupplierSeeds() {
  return suppliersSeed.map(item => JSON.parse(JSON.stringify(item)));
}

